import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/TabbedSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
